var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewsFilterIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2026",
    "data-name": "Group 2026",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26.561,
    height: 18.547,
    viewBox: "0 0 26.561 18.547",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1625",
    "data-name": "Rectangle 1625",
    width: 26.561,
    height: 18.547,
    fill: "#707b87"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2025",
    "data-name": "Group 2025",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_659",
    "data-name": "Path 659",
    d: "M25.513,0,.939.016a1.359,1.359,0,0,0-.09,2.552H25.712A1.349,1.349,0,0,0,25.513,0",
    transform: "translate(0)",
    fill: "#707b87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_660",
    "data-name": "Path 660",
    d: "M65.546,96l-16.607.016a1.359,1.359,0,0,0-.09,2.552h16.9a1.349,1.349,0,0,0-.2-2.567",
    transform: "translate(-44.016 -88.033)",
    fill: "#707b87"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_661",
    "data-name": "Path 661",
    d: "M105.638,192.068l-8.7.01a1.356,1.356,0,0,0,.052,2.6h8.645a1.353,1.353,0,0,0,0-2.606",
    transform: "translate(-88.035 -176.128)",
    fill: "#707b87"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewsFilterIcon);
export default __webpack_public_path__ + "static/media/NewsFilterIcon.230505607443bae18231c2dd386977fa.svg";
export { ForwardRef as ReactComponent };